import es from './es.json';
import en from './en.json';

type Lang = 'es' | 'en';

const translations = { es, en };

let currentLang: Lang = 'es';

export const t = (key: string, params?: Record<string, string | number>) => {
  const text = key.split('.').reduce((obj: any, i) => obj?.[i], translations[currentLang]) || key;
  
  if (params && typeof text === 'string') {
    return Object.entries(params).reduce((str, [key, value]) => {
      return str.replace(new RegExp(`{{${key}}}`, 'g'), String(value));
    }, text);
  }
  
  return text;
};

export const setLanguage = (lang: Lang) => {
  currentLang = lang;
};
